<table
	cdk-table
	class="ic-table"
	multiTemplateDataRows
	[class.fixed-layout]="fixedLayout"
	[class.has-detail-rows]="detailRowTemplate"
	[class.has-footer]="hasFooter"
	[class.sticky-footer]="stickyFooter"
	[dataSource]="tableItems || []"
>
	@if (borderIndicationTemplate) {
		<ng-container cdkColumnDef="borderIndicationColumn">
			<th *cdkHeaderCellDef cdk-header-cell>
				@if (borderIndicationTemplate.header) {
					<ng-template [ngTemplateOutlet]="borderIndicationTemplate.header" />
				}
			</th>
			<td *cdkCellDef="let row" cdk-cell class="ic-border-indication">
				@if (borderIndicationTemplate.cell) {
					<ng-template
						[ngTemplateOutlet]="borderIndicationTemplate.cell"
						[ngTemplateOutletContext]="{ $implicit: row }"
					/>
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	@if (expandTemplate) {
		<ng-container cdkColumnDef="expandColumn">
			<th *cdkHeaderCellDef cdk-header-cell class="ic-table-expand-column-header">
				@if (expandTemplate.header) {
					<ng-template [ngTemplateOutlet]="expandTemplate.header" />
				}
			</th>
			<td *cdkCellDef="let row" cdk-cell class="ic-table-expand-column" (click)="expandClick.emit(row)">
				@if (expandTemplate.cell) {
					<ng-template [ngTemplateOutlet]="expandTemplate.cell" [ngTemplateOutletContext]="{ $implicit: row }" />
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	@if (selectTemplate) {
		<ng-container cdkColumnDef="selectColumn">
			<th *cdkHeaderCellDef cdk-header-cell class="ic-table-select-column-header">
				@if (selectTemplate.header) {
					<ng-template [ngTemplateOutlet]="selectTemplate.header" />
				}
			</th>
			<td *cdkCellDef="let row" cdk-cell class="ic-table-select-column">
				@if (selectTemplate.cell) {
					<ng-template [ngTemplateOutlet]="selectTemplate.cell" [ngTemplateOutletContext]="{ $implicit: row }" />
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	@if (iconTemplate) {
		<ng-container cdkColumnDef="iconColumn">
			<th *cdkHeaderCellDef cdk-header-cell class="ic-table-icon-column-header">
				@if (iconTemplate.header) {
					<ng-template [ngTemplateOutlet]="iconTemplate.header" />
				}
			</th>
			<td *cdkCellDef="let row" cdk-cell class="ic-table-icon-column">
				@if (iconTemplate.cell) {
					<ng-template [ngTemplateOutlet]="iconTemplate.cell" [ngTemplateOutletContext]="{ $implicit: row }" />
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	@if (detailRowTemplate) {
		<ng-container cdkColumnDef="detailColumn">
			<td *cdkCellDef="let row" cdk-cell class="ic-table-detail-row" [attr.colspan]="columns.length">
				@if (detailRowTemplate.cell) {
					<ng-template [ngTemplateOutlet]="detailRowTemplate.cell" [ngTemplateOutletContext]="{ $implicit: row }" />
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	@for (column of tableColumns; track column) {
		<ng-container [cdkColumnDef]="column">
			<th *cdkHeaderCellDef cdk-header-cell>
				@if (templateMap.get(column)) {
					<ng-template [ngTemplateOutlet]="templateMap.get(column).header" />
				} @else {
					{{ column }}
				}
			</th>

			<td *cdkCellDef="let row" cdk-cell>
				@if (templateMap.get(column) && templateMap.get(column).cell) {
					<ng-template
						[ngTemplateOutlet]="templateMap.get(column).cell"
						[ngTemplateOutletContext]="{ $implicit: row[column], row: row }"
					/>
				} @else {
					{{ row[column] }}
				}
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell>
				@if (templateMap.get(column) && templateMap.get(column).footer) {
					<ng-template [ngTemplateOutlet]="templateMap.get(column).footer" />
				}
			</td>
		</ng-container>
	}

	@if (actionsTemplate) {
		<ng-container cdkColumnDef="actionsColumn">
			<th *cdkHeaderCellDef cdk-header-cell class="ic-table-actions-header">
				@if (actionsTemplate.header) {
					<ng-template [ngTemplateOutlet]="actionsTemplate.header" />
				}
			</th>

			<td *cdkCellDef="let row; let index = dataIndex" cdk-cell class="ic-table-actions">
				<ng-template [ngTemplateOutlet]="actionsTemplate?.cell" [ngTemplateOutletContext]="{ $implicit: row, index }" />
			</td>

			<td *cdkFooterCellDef="let row" cdk-footer-cell></td>
		</ng-container>
	}

	<tr *cdkHeaderRowDef="columns" cdk-header-row></tr>

	@if (!loading && !error && items && items.length > 0) {
		<tr
			*cdkRowDef="let row; columns: columns"
			cdk-row
			[class.disabled-row]="disableRowComparator(row)"
			(click)="rowClick.emit(row)"
		></tr>

		@if (detailRowTemplate) {
			<tr *cdkRowDef="let row; columns: ['detailColumn']" cdk-row class="ic-table-detail-row"></tr>
		}
	}

	<tr *cdkFooterRowDef="columns" cdk-footer-row></tr>
</table>

@if (!error && !loading && (!items || items.length === 0)) {
	<div class="ic-table-empty">
		<ng-template [ngTemplateOutlet]="emptyStateTemplate" />
	</div>
}

@if (loading) {
	<div class="ic-table-empty">
		<ng-template [ngTemplateOutlet]="loadingTemplate" />
	</div>
}

@if (!loading && error) {
	<div class="ic-table-empty">
		<ng-template [ngTemplateOutlet]="errorTemplate" />
	</div>
}

@if (buttonTemplate) {
	<div class="ic-table-buttons">
		<div class="ic-table-button-container">
			<ng-template [ngTemplateOutlet]="buttonTemplate" [ngTemplateOutletContext]="{ $implicit: 'previous' }" />
		</div>
		<div class="ic-table-button-container">
			<ng-template [ngTemplateOutlet]="buttonTemplate" [ngTemplateOutletContext]="{ $implicit: 'next' }" />
		</div>
	</div>
}

@if (pagingTemplate && pagingParams && (pagingParams.before || pagingParams.after)) {
	<div class="ic-table-buttons ic-table-button-container">
		<ng-template [ngTemplateOutlet]="pagingTemplate" />
	</div>
}
